// src/components/LanguageSwitcher.js
// Drop this into your Navbar, right before the sign-out button:
//   <LanguageSwitcher />

import { useLang } from '../hooks/useLang';
import './LanguageSwitcher.css';

const LANGS = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'de', label: 'DE', flag: '🇩🇪' },
  { code: 'ar', label: 'عر', flag: '🇹🇳' },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {LANGS.map(l => (
        <button
          key={l.code}
          className={'lang-btn' + (lang === l.code ? ' active' : '')}
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          title={l.flag + ' ' + l.label}
        >
          <span className="lang-flag">{l.flag}</span>
          <span className="lang-label">{l.label}</span>
        </button>
      ))}
    </div>
  );
}